import { render, staticRenderFns } from "./action_columns.vue?vue&type=template&id=6fca79fd"
import script from "./action_columns.vue?vue&type=script&lang=js"
export * from "./action_columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports